// extracted by mini-css-extract-plugin
module.exports = {"accent":"YvwgIVjX","muted":"_3J2C7ruT","dark":"Rjnh7lPh","light":"_2EI-DcP7","hoverableImage":"_2XjsOVWt _1qoRxAn1 _2_EZ9-MP"};